var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"rounded-card",attrs:{"dark":"","width":"200px","outlined":""}},[_c('v-card-title',[_vm._v(_vm._s(_vm.title))]),_c('v-card-text',[_vm._v(_vm._s(_vm.text))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }